<template>
  <div class="home">
    <!-- Header -->
    <Header />

    <!-- Hero Section -->
    <section class="hero-section">
      <div class="carousel">
        <div
          class="carousel-slide"
          v-for="(slide, index) in carouselSlides"
          :key="index"
          :class="{ active: currentSlide === index }"
        >
          <img :src="slide.image" :alt="slide.text" />
          <div class="carousel-content">
            <h1>{{ slide.text }}</h1>
            <p>{{ slide.description }}</p>
            <button class="shop-now-btn">Shop Now</button>
          </div>
        </div>
      </div>
    </section>

    <!-- Featured Categories -->
    <section class="featured-categories">
      <h2>Featured Categories</h2>
      <div class="categories-grid">
        <div
          class="category-card"
          v-for="category in categories"
          :key="category.name"
        >
          <img :src="category.image" :alt="category.name" />
          <h3>{{ category.name }}</h3>
          <p>{{ category.description }}</p>
        </div>
      </div>
    </section>

    <!-- Trending Products -->
    <section class="trending-products">
      <h2>Trending Products</h2>
      <div class="products-grid">
        <div
          class="product-card"
          v-for="product in trendingProducts"
          :key="product.id"
        >
          <img :src="product.image" :alt="product.name" />
          <h3>{{ product.name }}</h3>
          <div class="price">
            <span class="original-price">Tsh:{{ product.originalPrice }}</span>
            <span class="selling-price">Tsh:{{ product.sellingPrice }}</span>
          </div>
          <div class="rating">
            <span
              v-for="star in 5"
              :key="star"
              :class="{ filled: star <= product.rating }"
            >
              ⭐
            </span>
          </div>
          <button class="add-to-cart-btn">Add to Cart</button>
        </div>
      </div>
    </section>

    <!-- Special Offers -->
    <section class="special-offers">
      <h2>Special Offers</h2>
      <div class="offers-grid">
        <div class="offer-card" v-for="offer in specialOffers" :key="offer.id">
          <img :src="offer.image" :alt="offer.name" />
          <h3>{{ offer.name }}</h3>
          <p>{{ offer.description }}</p>
          <button class="view-offer-btn">View Offer</button>
        </div>
      </div>
    </section>

    <!-- Footer -->

  <!-- <FloatingActionButton /> -->

    <Footer />
  </div>
</template>

<script setup>
import { ref, onMounted } from "vue";
import Header from "../components/Header.vue";
import Footer from "../components/Footer.vue";
import FloatingActionButton from "../components/FloatingMenu.vue";

// Carousel Data
const carouselSlides = ref([
  {
    image: require("@/assets/img/hero/hero-1.png"),
    text: "Welcome to EKU MARKET",
    description: "Your one-stop shop for all your needs",
  },
  {
    image: require("@/assets/img/hero/hero-2.jpg"),
    text: "Explore Our Products",
    description: "Find the best deals on health, clothing, and more",
  },
  {
    image: require("@/assets/img/product/img-3.jpeg"),
    text: "Trending Now",
    description: "Shop the latest trends in fashion and vehicles",
  },
  {
    image: require("@/assets/img/product/img-4.jpeg"),
    text: "Special Offers",
    description: "Get exclusive discounts on selected items",
  },
]);

const currentSlide = ref(0);

// Auto-play Carousel
onMounted(() => {
  setInterval(() => {
    currentSlide.value = (currentSlide.value + 1) % carouselSlides.value.length;
  }, 5000); // Change slide every 5 seconds
});

// Sample Data
const categories = ref([
  {
    name: "Health",
    image: require("@/assets/img/product/img-1.jpg"),
    description: "Explore our health products.",
  },
  {
    name: "Clothing",
    image: require("@/assets/img/product/img-2.jpg"),
    description: "Shop the latest fashion trends.",
  },
  {
    name: "Vehicles",
    image: require("@/assets/img/product/img-3.jpeg"),
    description: "Find your dream vehicle.",
  },
]);

const trendingProducts = ref([
  {
    id: 1,
    name: "Product 1",
    image: require("@/assets/img/product/img-4.jpeg"),
    originalPrice: 55000,
    sellingPrice: 49999,
    rating: 4, // Star rating (out of 5)
  },
  {
    id: 2,
    name: "Product 2",
    image: require("@/assets/img/product/img-5.webp"),
    originalPrice: 25000,
    sellingPrice: 22000,
    rating: 3, // Star rating (out of 5)
  },
  {
    id: 3,
    name: "Product 3",
    image: require("@/assets/img/product/img-6.jpg"),
    originalPrice: 2000,
    sellingPrice: 1200,
    rating: 5, // Star rating (out of 5)
  },
  {
    id: 4,
    name: "Product 4",
    image: require("@/assets/img/product/img-7.jpg"),
    originalPrice: 10000,
    sellingPrice: 8500,
    rating: 2, // Star rating (out of 5)
  },
]);

const specialOffers = ref([
  {
    id: 1,
    name: "Offer 1",
    image: require("@/assets/img/product/img-1.jpg"),
    description: "Get 20% off on selected items.",
  },
  {
    id: 2,
    name: "Offer 2",
    image: require("@/assets/img/product/img-2.jpg"),
    description: "Buy one, get one free.",
  },
]);
</script>

<style scoped>
/* General Styles */
.home {
  font-family: Arial, sans-serif;
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}

/* Hero Section */
.hero-section {
  position: relative;
  height: 400px;
  overflow: hidden;
}

.carousel {
  position: relative;
  width: 100%;
  height: 100%;
}

.carousel-slide {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  opacity: 0;
  transition: opacity 1s ease-in-out;
}

.carousel-slide.active {
  opacity: 1;
}

.carousel-slide img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.carousel-content {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  text-align: center;
  color: #555;
  /* color: #fff; */
}

.carousel-content h1 {
  font-size: 3rem;
  margin-bottom: 10px;
}

.carousel-content p {
  font-size: 1.5rem;
  margin-bottom: 20px;
}

.shop-now-btn {
  padding: 10px 20px;
  font-size: 1rem;
  background-color: #42b983;
  color: #fff;
  border: none;
  border-radius: 4px;
  cursor: pointer;
}

.shop-now-btn:hover {
  background-color: #369f6e;
}

/* Featured Categories */
.featured-categories {
  padding: 40px 20px;
  text-align: center;
}

.featured-categories h2 {
  font-size: 2rem;
  margin-bottom: 20px;
}

.categories-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));
  gap: 20px;
}

.category-card {
  background-color: #fff;
  border: 1px solid #ddd;
  border-radius: 8px;
  padding: 20px;
  text-align: center;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
}

.category-card img {
  width: 100%;
  height: 150px;
  object-fit: cover;
  border-radius: 8px;
}

.category-card h3 {
  font-size: 1.5rem;
  margin: 10px 0;
}

.category-card p {
  font-size: 1rem;
  color: #666;
}

/* Trending Products */
.trending-products {
  padding: 40px 20px;
  text-align: center;
}

.trending-products h2 {
  font-size: 2rem;
  margin-bottom: 20px;
}

.products-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
  gap: 20px;
}

.product-card {
  background-color: #fff;
  border: 1px solid #ddd;
  border-radius: 8px;
  padding: 15px;
  text-align: center;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
}

.product-card img {
  width: 100%;
  height: 150px;
  object-fit: cover;
  border-radius: 8px;
}

.product-card h3 {
  font-size: 1.2rem;
  margin: 10px 0;
}

.price {
  margin: 10px 0;
}

.original-price {
  text-decoration: line-through;
  color: #999;
  margin-right: 10px;
}

.selling-price {
  font-weight: bold;
  color: #42b983;
}

.rating {
  margin: 10px 0;
  color: #ffc107;
}

.rating .filled {
  color: #ffc107;
}

.add-to-cart-btn {
  padding: 10px 20px;
  font-size: 1rem;
  background-color: #42b983;
  color: #fff;
  border: none;
  border-radius: 4px;
  cursor: pointer;
}

.add-to-cart-btn:hover {
  background-color: #369f6e;
}

/* Special Offers */
.special-offers {
  padding: 40px 20px;
  text-align: center;
}

.special-offers h2 {
  font-size: 2rem;
  margin-bottom: 20px;
}

.offers-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));
  gap: 20px;
}

.offer-card {
  background-color: #fff;
  border: 1px solid #ddd;
  border-radius: 8px;
  padding: 20px;
  text-align: center;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
}

.offer-card img {
  width: 100%;
  height: 150px;
  object-fit: cover;
  border-radius: 8px;
}

.offer-card h3 {
  font-size: 1.5rem;
  margin: 10px 0;
}

.offer-card p {
  font-size: 1rem;
  color: #666;
}

.view-offer-btn {
  padding: 10px 20px;
  font-size: 1rem;
  background-color: #007bff;
  color: #fff;
  border: none;
  border-radius: 4px;
  cursor: pointer;
}

.view-offer-btn:hover {
  background-color: #0056b3;
}
</style>
